import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "/nav-logo.png";

export const Footer = () => {
  return (
    <footer data-testid="footer" style={{
      background: '#6A0DAD',
      borderTop: '4px solid #000',
      padding: '4rem 1.5rem 2rem',
      color: '#fff',
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '2.5rem',
          marginBottom: '3rem',
        }}>
          <div>
            <img src={LOGO_URL} alt="HungrMates" style={{ height: '60px', width: 'auto', marginBottom: '1rem' }} />
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, fontSize: '0.9375rem' }}>
              More Orders. More Customers. More Superpower.
            </p>
          </div>

          <div>
            <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', letterSpacing: '0.04em', marginBottom: '1rem', textTransform: 'uppercase' }}>
              Quick Links
            </h3>
            {[
              { to: '/pricing', label: 'Pricing' },
              { to: '/portfolio', label: 'Portfolio' },
              { to: '/roi', label: 'ROI Calculator' },
              { to: '/book-demo', label: 'Book Demo' },
              { to: '/grade-my-site', label: 'Grade My Site' },
            ].map(link => (
              <Link key={link.to} to={link.to} style={{
                display: 'block',
                color: 'rgba(255,255,255,0.8)',
                textDecoration: 'none',
                padding: '0.25rem 0',
                fontWeight: 600,
                transition: 'color 0.15s',
              }}
              onMouseEnter={(e) => e.target.style.color = '#FFD700'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div>
            <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', letterSpacing: '0.04em', marginBottom: '1rem', textTransform: 'uppercase' }}>
              Contact Us
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Mail size={18} color="#FFD700" />
                <span style={{ color: 'rgba(255,255,255,0.8)' }}>Mike@hungrmates.com</span>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Phone size={18} color="#FFD700" />
                <span style={{ color: 'rgba(255,255,255,0.8)' }}>(470) 526-0852</span>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <MapPin size={18} color="#FFD700" />
                <span style={{ color: 'rgba(255,255,255,0.8)' }}>Atlanta, GA</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{
          borderTop: '3px solid rgba(255,255,255,0.2)',
          paddingTop: '1.5rem',
          textAlign: 'center',
          color: 'rgba(255,255,255,0.6)',
          fontSize: '0.875rem',
          fontWeight: 600,
        }}>
          &copy; {new Date().getFullYear()} HungrMates. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
